import { AvailabilityIssue } from "@app/view/shared/alerts/alert-tool/availability.issue";
import { TicketIssue } from "@app/view/shared/alerts/alert-tool/ticket.issue";

export class DayProblems {
  date: Date;
  totalAlerts: 0;
  reservationAlerts: 0;
  seriousAlerts: 0;

  resourceAvailabilities: AvailabilityIssue[];
  tickets: TicketIssue[];
}
